import { ReplacementOffer } from './replacement.offer.model';
import { CurrentItem } from './current.item.model';

export type Comparison = CurrentItem & ReplacementOffer;
